<script>
import Layout from "@/router/layouts/auth";
import { api } from "@/state/services";
import { mapState } from "vuex";
import { required, email } from "vuelidate/lib/validators";
import Languages from "@/components/widgets/languages";

export default {
  locales: {
    pt: {
      "E-mail": "E-mail",
      "E-mail is required.": "E-mail é obrigatório.",
      "This value should be a valid e-mail.":
        "Este valor deve ser um e-mail válido.",
      Recover: "Recuperar",
      "Remember It?": "Lembrou-se?",
      "Sign In here": "Entrar",
      "The email is invalid.": "O email é inválido.",
      "A code for creating a new password has been sent to your email and you have up to 24 hours to change your password.":
        "Um código para criar uma nova senha foi enviado ao seu e-mail e você tem até 24 horas para alterar sua senha.",
    },
    es: {
      "E-mail": "E-mail",
      "E-mail is required.": "Correo electronico es requerido.",
      "This value should be a valid e-mail.":
        "Este valor debe ser un correo electrónico válido.",
      Recover: "Recuperar",
      "Remember It?": "¿Recuerdalo?",
      "Sign In here": "Identifícate aquí",
      "The email is invalid.": "El correo electrónico no es válido.",
      "A code for creating a new password has been sent to your email and you have up to 24 hours to change your password.":
        "Se ha enviado un código para crear una nueva contraseña a su correo electrónico y tiene hasta 24 horas para cambiar su contraseña.",
    },
  },
  components: {
    Layout,
    Languages,
  },
  data() {
    return {
      loading: false,
      success: false,
      cellphone: "",
      email: "",
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
  },
  validations: {
    cellphone: { required },
    email: { required, email },
  },
  methods: {
    recoverSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.loading = true;

        if (this.cellphone && this.email) {
          api
            .post("password/recover", {
              cellphone: this.cellphone,
              email: this.email,
            })
            .then((response) => {
              if (response.data.status == "success") {
                this.email = "";
                this.$v.$reset();

                this.alert.type = "alert-success";
                this.alert.message = response.data.message;

                this.success = true;
              } else {
                this.alert.type = "alert-danger";
                this.alert.message = response.data.message;
              }

              this.loading = false;
            });
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5">
          <router-link class="align-middle" tag="a" to="/">
            <img class="w-100" style="max-width: 200px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <div v-if="success" class="p-4">
            {{ t(this.alert.message) }}
          </div>
          <b-form v-else @submit.prevent="recoverSubmit">
            <div v-if="alert.message" :class="'alert ' + alert.type">
              {{ t(alert.message) }}
            </div>
            <b-form-group id="cellphone" :label="t('Celular')" label-for="cellphone">
              <b-form-input id="cellphone" v-model="cellphone" type="text" inputmode="numeric" :class="{ 'is-invalid': submitted && $v.cellphone.$error }" v-mask="'(##) #####-####'"></b-form-input>
              <div v-if="submitted && !$v.cellphone.required" class="invalid-feedback">
                {{ t("Cellphone is required.") }}
              </div>
            </b-form-group>
            <b-form-group id="email" :label="t('E-mail')" label-for="email">
              <b-form-input id="email" v-model="email" type="email" :class="{ 'is-invalid': $v.email.$error }"></b-form-input>
              <div v-if="$v.email.$error" class="invalid-feedback">
                <span v-if="!$v.email.required">{{
                  t("E-mail is required.")
                  }}</span>
                <span v-if="!$v.email.email">{{
                  t("This value should be a valid e-mail.")
                  }}</span>
              </div>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                {{ t("Recover") }}
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
            </div>
          </b-form>
          <div class="mt-4">
            <p class="text-dark text-center">
              {{ t("Remember It?") }}
              <router-link tag="a" to="/login" class="font-weight-medium text-muted">{{ t("Sign In here") }}</router-link>
            </p>
            <Languages class="d-none" type="dropup"></Languages>
            <hr class="my-5" />
            <p class="font-size-12 text-uppercase text-muted text-center">
              <a class="text-muted font-size-11" target="_blank" href="https://m2n.com.br/?utm_source=playprotv.com&utm_medium=link&utm_campaign=logo">
                TECNOLOGIA POR<br>
                <img alt="M2N" style="width: 50px" src="@/assets/images/logo-m2n.svg" />
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block"></div>
    </div>
  </Layout>
</template>
